import { Host, h } from '@stencil/core';
import cn from 'classnames';
import { pesIconMirrorDirection, pesIconSizes } from '@pes-ui/utils';
export class CollapsibleContainer {
  constructor() {
    this.toggle = () => {
      this.isCollapsed = !this.isCollapsed;
    };
    this.toggleColor = 'default';
    this.isCollapsed = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h(Host, { class: cn({ collapsed: this.isCollapsed }) }, h("div", { class: "header", onClick: this.toggle }, h("div", { class: "heading" }, h("slot", { name: "header" })), h("div", { class: `collapse-toggle collapse-toggle--color-${this.toggleColor}` }, h("pes-icon", { size: pesIconSizes.MICRO, mirror: !this.isCollapsed ? pesIconMirrorDirection.VERTICAL : undefined }, "arrow2_down"))), h("div", { class: "content" }, h("slot", null))));
  }
  static get is() { return "pes-collapsible-container"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["collapsible-container.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["collapsible-container.css"]
    };
  }
  static get properties() {
    return {
      "toggleColor": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'default' | 'inherit'",
          "resolved": "\"default\" | \"inherit\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines the toggle color. By default $se-life-green."
        },
        "attribute": "toggle-color",
        "reflect": false,
        "defaultValue": "'default'"
      },
      "isCollapsed": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-collapsed",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get elementRef() { return "el"; }
}
